export const AGENT_ROUTES = {
  index: {
    path: 'agent/*',
    to: '/agent/dashboard',
  },
  agent: {
    path: 'agent/*',
    to: '/agent/dashboard',
  },
  dashboard: {
    path: 'dashboard/*',
    to: '/agent/dashboard',
  },
  createLink: {
    path: 'create-link',
    to: 'agent/create-link',
  },
};
